import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { Icons } from "../../../enums/icons-enums";

@Component({
  selector: "app-confirmation-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./confirmation-dialog.component.html",
  styleUrl: "./confirmation-dialog.component.css",
})
export class ConfirmationDialogComponent {
  icons = Icons;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; message?: string }
  ) {}
}
